import { Language } from 'src/app/util/lang';
import { ProviderItemInputs } from './../../../models/provider-item-inputs';
import { ProviderInfo } from './../../../models/provider-info';
import { ProvidersService } from './../../../services/providers.service';
import { ProviderInput } from './../../../models/provider-input';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { getKeyAndValueFromForm, checkProviderValidations } from 'src/app/util/tools';
import { ProviderDetails } from 'src/app/models/provider-details';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-provider',
  templateUrl: './provider.component.html',
  styleUrls: ['./provider.component.scss']
})
export class ProviderComponent implements OnInit {

  public providerInput: ProviderInput[] = [];
  public providerInfo: ProviderInfo;
  public form: FormGroup;
  public items: ProviderItemInputs[] = [];
  public errors: ProviderItemInputs[] = [];
  public showPopup: boolean = false;
  public popupMessage: string;
  public popupMessages: ProviderItemInputs[];
  public group: any = {};
  public guid: string;
  public showLoading: boolean = false;
  public messages: any;
  constructor(
    public providersService: ProvidersService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location,
    private translate: TranslateService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      const { id } = params;
      this.getTranslations();
      this.getProviderInputs(id)
        .then(() => this.getProviderInfo(id))
        .catch();
      this.guid = id;
    })
  }

  public getTranslations() {
    this.translate.get('Messages').subscribe((data) => {
      this.messages = data;
    });
  }

  public onDropdownChange(event){

  }

  toFormGroup(providerInputs: ProviderInput[]) {
    for (let i = 0; i < providerInputs.length; i++) {
      if (providerInputs[i].Keyboard == "dropdown") {
        this.group[`input_${providerInputs[i].Id}`] = new FormControl( providerInputs[i].Format[0].value);
      }
      else {
        this.group[`input_${providerInputs[i].Id}`] = new FormControl(providerInputs[i].DefaultValue);
      }
    }
    return new FormGroup(this.group);
  }

  public async getProviderInputs(id: string): Promise<void> {
    this.providersService.getProviderInputs(id).subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        this.router.navigate([`notfound`]);
      } else if (!response) { /// in some case the operation status is ok, but data is null, api error, but handled here
        this.router.navigate([`notfound`]);///
      }
      else {
        response.forEach(i => {
          this.providerInput.push(new ProviderInput(i));
        });
        this.providersService.setCurrency(null);
        this.form = this.toFormGroup(this.providerInput);
      };
    });
  }

  public getProviderInfo(id: string): void {
    this.providersService.getProviderInfo(id).subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        this.router.navigate([`notfound`]);
      }
      else {
        this.providerInfo = new ProviderInfo(response.Object);
        this.setTitle(this.providerInfo.Name);
      }
    })
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public showErrors(errors: ProviderItemInputs[]): void {
    let message: string = '';
    for (let i = 0; i < errors.length; i++) {
      message += ` ${errors[i].Value},`;
    }
    this.showPopup = true;
    this.popupMessages = errors;
  }

  public handleResult(item: ProviderDetails): void {
    const { Status } = item;
    const lang = Language.getCurrentLang();
    switch (Status) {
      case 200:
        this.router.navigate([`${lang}/pay/${this.guid}`]);
        break;
      case 300:
        this.router.navigate([`${lang}/chooseabonent/${this.guid}`]);
        break;
      default:
        this.popupMessage = this.messages.wrongdata;
        this.showPopup = true;
        break;
    }
  }


  public back(): void {
    this.location.back();
  }


  public onSubmit() {
    const formData = this.form.getRawValue();
    this.items = getKeyAndValueFromForm(formData);
    const providerData = checkProviderValidations(this.providerInput, this.items, this.translate.getDefaultLang());
    if (!providerData.valid) {
      this.showErrors(providerData.errors);
    } else {
      this.showLoading = true;
      this.providersService.checkProviderItemInputs(providerData.items).subscribe(response => {
        if (response instanceof HttpErrorResponse || response.status === 400) {
          this.popupMessage = this.messages.wrongdata;
          this.showPopup = true;
        }
        else {
          this.items.map(i => {
            this.providerInput.map(input => {
              if (input.ForRequest && input.Id.toString() == i.ProviderInputId) {
                this.providersService.setCurrency(i.Value);
              }
            });
          });
          this.handleResult(response);
        }
        this.showLoading = false;
      });
    }
  }
}
